module.exports = __webpack_public_path__ + "img/aubrey-odom-ITzfgP77DTg-unsplash.b4c65b79.jpg";